module.exports = __webpack_public_path__ + "static/media/Stvler.0c2dfe85.mp3";